import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMenu, FiX, FiBell } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const logoUrl = "https://media-manager-c.questera.ai/greta-media/0fbf60f8fa242397e9ef833782db8ed93045df54e3b36d72437cb9900e44cd21f118b78650ffb5dd82aaaddf0850c39a/images/aW1hZ2UvanBlZw==/f2db29be14ca2eb40f068da8d183a853.jpeg";

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/reminders', label: 'Reminders' },
    { path: '/about', label: 'About' },
    { path: '/faq', label: 'FAQ' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="bg-gray-900 shadow-lg sticky top-0 z-50 border-b border-gray-800" role="banner">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3" aria-label="Ramirez Mobile Homepage">
            <img src={logoUrl} alt="Ramirez Mobile Clean Truck Check Logo" className="h-16 w-auto object-contain" />
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-white leading-tight">Ramirez Mobile</h1>
              <p className="text-xs text-blue-400 font-medium tracking-wide">CLEAN TRUCK CHECK</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" role="navigation" aria-label="Main Navigation">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`font-medium transition-colors flex items-center gap-1 ${location.pathname === item.path ? 'text-blue-400' : 'text-gray-300 hover:text-blue-400'}`}
                aria-current={location.pathname === item.path ? 'page' : undefined}
                title={`Navigate to ${item.label}`}
              >
                {item.label === 'Reminders' && <SafeIcon icon={FiBell} className="text-sm" aria-hidden="true" />}
                {item.label}
              </Link>
            ))}
            <a 
              href="tel:9092842738" 
              className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors shadow-lg shadow-blue-900/20 whitespace-nowrap"
              aria-label="Call Ramirez Mobile at (909) 284-2738"
            >
              <SafeIcon icon={FiPhone} aria-hidden="true" />
              <span>(909) 284-2738</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="md:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors"
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? "Close main menu" : "Open main menu"}
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl" aria-hidden="true" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.nav 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden pb-4 border-t border-gray-800 bg-gray-900"
            role="navigation"
            aria-label="Mobile Navigation"
          >
            <div className="flex flex-col space-y-4 pt-4 px-2">
              {navItems.map((item) => (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium flex items-center gap-3 p-3 rounded-lg transition-colors ${location.pathname === item.path ? 'bg-blue-900/30 text-blue-400' : 'text-gray-300 hover:bg-gray-800'}`}
                  aria-current={location.pathname === item.path ? 'page' : undefined}
                >
                  {item.label === 'Reminders' && <SafeIcon icon={FiBell} aria-hidden="true" />}
                  {item.label}
                </Link>
              ))}
              <a 
                href="tel:9092842738" 
                className="flex items-center justify-center space-x-2 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 font-bold mt-2"
                aria-label="Call Ramirez Mobile at (909) 284-2738"
              >
                <SafeIcon icon={FiPhone} aria-hidden="true" />
                <span>Call (909) 284-2738</span>
              </a>
            </div>
          </motion.nav>
        )}
      </div>
    </header>
  );
};

export default Header;